module.exports = __webpack_public_path__ + "static/media/6 wolf triangles arm black white.1280x1707.0410ef02.webp";